import { useEffect, useState } from "react";
import { api } from "../api.ts";
import { inicioSemana, sumarDias, fechaLarga, horaLarga, NOMBRE_ESTADO_CITA } from "../../../dominio/src/index.ts";
import { AvisoError, hoy, Seccion, useAccion } from "./comun.tsx";

export interface CuentaClinica { usuarioId: string; clinicaId: string; clinica: string; rol: string; actual: boolean }
interface CitaMia { id: string; clinica_id: string; clinica: string; sede: string | null; fecha: string; hora: string; horaFin: string; estado: keyof typeof NOMBRE_ESTADO_CITA; paciente: string; motivo: string }
const COLORES = ["#0A6E5C", "#2459C9", "#935400", "#6B3FA0", "#9E2B4E", "#33475B"];

/**
 * Mi agenda: las citas de este profesional en todas sus clínicas y sedes, juntas (solo las suyas, con el primer nombre y la inicial del paciente).
 * Para editar una cita, se toca y Donna lo lleva a esa clínica, en ese día.
 */
export function MiAgenda({ cuentas, ir, cambiar }: { cuentas: CuentaClinica[]; ir: (r: string) => void; cambiar: (usuarioId: string, destino: string) => void }) {
  const [lunes, setLunes] = useState(() => { const h = hoy(); const w = new Date(h + "T12:00:00Z").getUTCDay(); return w === 0 ? sumarDias(h, 1) : inicioSemana(h); });
  const [citas, setCitas] = useState<CitaMia[]>([]);
  const a = useAccion();
  const dias = Array.from({ length: 6 }, (_, i) => sumarDias(lunes, i));
  const color = (id: string) => COLORES[Math.max(0, cuentas.findIndex((c) => c.clinicaId === id)) % COLORES.length];
  useEffect(() => { a.correr(() => api<CitaMia[]>("GET", `/api/mi-agenda?desde=${dias[0]}&hasta=${dias[5]}`)).then((r) => r && setCitas(r)); }, [lunes]);

  function abrir(c: CitaMia) {
    const destino = `agenda?dia=${c.fecha}`;
    const cuenta = cuentas.find((x) => x.clinicaId === c.clinica_id);
    if (!cuenta || cuenta.actual) { ir(destino); return; }
    cambiar(cuenta.usuarioId, destino);
  }
  return (
    <>
      <div className="fila" style={{ justifyContent: "space-between" }}>
        <h1>Mi agenda</h1>
        <span className="fila" style={{ flexWrap: "wrap" }}>{cuentas.map((c) => <span key={c.clinicaId} className="chip" style={{ borderColor: color(c.clinicaId), color: color(c.clinicaId) }}>{c.clinica}</span>)}</span>
      </div>
      <p className="muted" style={{ margin: 0, fontSize: 14 }}>Tus pacientes agendados en todas tus clínicas y sedes. Toca una cita para abrirla en su clínica y editarla.</p>
      <div className="fila barra-agenda">
        <button className="btn chico" onClick={() => setLunes(sumarDias(lunes, -7))} aria-label="Semana anterior">‹</button>
        <button className="btn chico" onClick={() => { const h = hoy(); setLunes(new Date(h + "T12:00:00Z").getUTCDay() === 0 ? sumarDias(h, 1) : inicioSemana(h)); }}>Hoy</button>
        <button className="btn chico" onClick={() => setLunes(sumarDias(lunes, 7))} aria-label="Semana siguiente">›</button>
        <b style={{ flex: 1 }}>Semana del {fechaLarga(lunes)}</b>
      </div>
      <AvisoError error={a.error} />
      <div className="mi-agenda">
        {dias.map((d) => {
          const delDia = citas.filter((c) => c.fecha === d).sort((x, y) => x.hora.localeCompare(y.hora));
          return (
            <Seccion key={d} titulo={fechaLarga(d).split(",")[0]}>
              <small className="muted">{d.slice(8)}/{d.slice(5, 7)}</small>
              {delDia.length === 0 && <span className="muted" style={{ fontSize: 13 }}>Sin citas</span>}
              {delDia.map((c) => (
                <button key={c.id} className={`cita-mia e-${c.estado}`} style={{ ["--c" as string]: color(c.clinica_id) }} onClick={() => abrir(c)}
                  aria-label={`${c.hora} ${c.paciente}, ${c.clinica}${c.sede ? `, ${c.sede}` : ""}, ${NOMBRE_ESTADO_CITA[c.estado]}`}>
                  <b>{horaLarga(c.hora)}</b> {c.paciente}{c.motivo && <span className="muted"> · {c.motivo}</span>}
                  <small>{c.clinica}{c.sede ? ` · ${c.sede}` : ""}{c.estado === "cancelada" ? " · cancelada" : ""}</small>
                </button>
              ))}
            </Seccion>
          );
        })}
      </div>
    </>
  );
}
